import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Link as MuiLink, CircularProgress, Alert } from '@mui/material'; // Added Link, CircularProgress, Alert
import { useNavigate } from 'react-router-dom';
import ApiService from '../../api/api_service'; 
import RegisterComponent from './registerComponent';

const LoginComponent = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState(null);
	const [welcomeMessage, setWelcomeMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [isRegistering, setIsRegistering] = useState(false);

	const navigate = useNavigate();

	const handleLogin = async (event) => {
		event.preventDefault();
		setError(null);

		try {
			const data = await ApiService.login(email, password);
			localStorage.removeItem('token');
			localStorage.setItem('token', data.access_token);
			localStorage.setItem('userEmail', email);
			setWelcomeMessage(`Welcome, ${email}!`);
		} catch (error) {
			setError(error.message);
		}
	};

	useEffect(() => {
		if (welcomeMessage) {
		const timer = setTimeout(() => {
			navigate('/');
		}, 2000); 

		return () => clearTimeout(timer);    
		}
	}, [welcomeMessage, navigate]);

	const toggleView = () => {
		setIsRegistering(!isRegistering);
		setError(null); // Clear errors when switching views
		setWelcomeMessage(''); // Clear welcome message
};
return (
	<Box sx={{ padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
		<Box sx={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
			<img src="/logo-small.png" alt="Logo" style={{ width: '60%', marginBottom: '20px' }} />

			{/* Display Welcome Message if login was successful */}
			{welcomeMessage && (
				<Alert severity="success" sx={{ mb: 2 }}>{welcomeMessage}</Alert>
			)}

			{/* Conditionally render Login Form or Register Component */}
			{!welcomeMessage && (
				isRegistering ? (
					// Pass toggleView function to RegisterComponent
					<RegisterComponent onSwitchToLogin={toggleView} />
				) : (
					// Login Form
					<form onSubmit={handleLogin} autoComplete="on">
						<Typography variant="h6" sx={{ mb: 2 }}>Login</Typography>
						<TextField
							label="Email"
							type="email" // Use email type
							variant="outlined"
							name="email"
							fullWidth
							autoComplete="email"
							sx={{ marginBottom: 2 }}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required // Add required
						/>
						<TextField
							label="Password"
							type="password"
							variant="outlined"
							name="password"
							fullWidth
							autoComplete="current-password"
							sx={{ marginBottom: 2 }}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required // Add required
						/>
						{error && (
							// Use Alert for better visibility
							<Alert severity="error" sx={{ marginBottom: 2 }}>
								{error}
							</Alert>
						)}
						<Box sx={{ position: 'relative', mt: 1, mb: 2 }}> {/* Wrapper for button/spinner */}
							<Button
								type="submit"
								variant="contained"
								color="primary"
								fullWidth
								disabled={loading} // Disable while loading
							>
								Login
							</Button>
							{loading && (
								<CircularProgress
									size={24}
									sx={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										marginTop: '-12px',
										marginLeft: '-12px',
									}}
								/>
							)}
						</Box>
						{/* Link to switch to Register view */}
						<Typography variant="body2">
							Don't have an account?{' '}
							<MuiLink component="button" variant="body2" onClick={toggleView} sx={{ cursor: 'pointer' }}>
								Register here
							</MuiLink>
						</Typography>
					</form>
				)
			)}
		</Box>
	</Box>
);
};

export default LoginComponent;
